// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1Ygqa","dragIcon":"SortableItem_dragIcon__2p67-","disabled":"SortableItem_disabled__38egk"};